"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsString_1 = __importDefault(require("../typeAssertions/valueIsString"));
const getValueByPathFromUnknown_1 = __importDefault(require("./getValueByPathFromUnknown"));
const fuzzySearch_1 = __importDefault(require("./fuzzySearch"));
const valueIsRecord_1 = __importDefault(require("../typeAssertions/valueIsRecord"));
const buildControlsByCategory = ({ categoryField, controls, processor, filterProperty, filterEnabled, searchInput, }) => {
    if (!(0, valueIsString_1.default)(categoryField)) {
        return [];
    }
    const pathToValue = `itemContext.data.${filterProperty}`;
    const categories = [];
    const computedSectionsData = controls.reduce((sectionsData, control) => {
        var _a, _b;
        const controlContext = processor.root.getControlRunContext(control.id);
        const contextData = (_a = controlContext === null || controlContext === void 0 ? void 0 : controlContext.itemContext) === null || _a === void 0 ? void 0 : _a.data;
        const rawFieldValue = (0, valueIsRecord_1.default)(contextData) ? contextData[categoryField] : undefined;
        if (!rawFieldValue) {
            return sectionsData;
        }
        const fieldValue = `${rawFieldValue}`;
        const controlData = {
            control,
            key: control.id,
        };
        if (filterEnabled && filterProperty && searchInput) {
            const controlWidthValue = (_b = control.controls) === null || _b === void 0 ? void 0 : _b[0];
            const controlWidthValueContext = controlWidthValue && processor.root
                .getControlRunContext(controlWidthValue.id);
            const propValue = (0, getValueByPathFromUnknown_1.default)(controlWidthValueContext, pathToValue.split('.'));
            const isMatch = (0, fuzzySearch_1.default)((searchInput || '').toLowerCase(), `${propValue}`.toLowerCase());
            if (!isMatch) {
                return sectionsData;
            }
        }
        const controlSection = sectionsData.find((section) => section.title === rawFieldValue);
        if (!controlSection) {
            categories.push(fieldValue);
            sectionsData.push({
                title: fieldValue,
                data: [controlData],
            });
        }
        else {
            controlSection.data.push(controlData);
        }
        return sectionsData;
    }, [])
        .filter((sectionData) => sectionData.data.length > 0);
    return [computedSectionsData, categories];
};
exports.default = buildControlsByCategory;
